export const ACL_RESOURCE_TYPE_DF_SOURCE = 'df_data_source';
export const ACL_RESOURCE_TYPE_DF_SINK = 'df_data_sink';
export const ACL_RESOURCE_TYPE_DF_DATASET = 'df_data_set';
export const ACL_RESOURCE_TYPE_DATASET = 'data_set';
export const ACL_RESOURCE_TYPE_SOURCE = 'data_sources';
export const ACL_RESOURCE_TYPE_DESTINATION = 'data_sinks';
export const ACL_RESOURCE_TYPE_TRANSFORM = 'code_containers';
export const ACL_RESOURCE_TYPE_CREDENTIALS = 'credentials';
export const ACL_RESOURCE_TYPE_LOOKUPS = 'data_maps';
export const ACL_RESOURCE_TYPE_PROJECTS = 'projects';
export const ACL_RESOURCE_TYPE_FLOW = 'flows';
export const ACL_RESOURCE_TYPE_SCHEMA_TEMPLATE = 'data_schemas';

export const ACL_RESOURCE_TYPE_ENDPOINTS = {
  [ACL_RESOURCE_TYPE_FLOW]: 'flows',
  [ACL_RESOURCE_TYPE_SOURCE]: 'data_sources',
  [ACL_RESOURCE_TYPE_DESTINATION]: 'data_sinks',
  [ACL_RESOURCE_TYPE_DATASET]: 'data_sets',
  [ACL_RESOURCE_TYPE_TRANSFORM]: 'code_containers',
  [ACL_RESOURCE_TYPE_CREDENTIALS]: 'data_credentials',
  [ACL_RESOURCE_TYPE_LOOKUPS]: 'data_maps',
  [ACL_RESOURCE_TYPE_PROJECTS]: 'projects',
  [ACL_RESOURCE_TYPE_SCHEMA_TEMPLATE]: 'data_schemas',
};
